<template>
  <path
    d="M20 18.0002C21.1 18.0002 22 17.1002 22 16.0002V6.00024C22 4.90024 21.1 4.00024 20 4.00024H4C2.9 4.00024 2 4.90024 2 6.00024V16.0002C2 17.1002 2.89 18.0002 4 18.0002H1C0.45 18.0002 0 18.4502 0 19.0002C0 19.5502 0.45 20.0002 1 20.0002H23C23.55 20.0002 24 19.5502 24 19.0002C24 18.4502 23.55 18.0002 23 18.0002H20ZM13 14.4702V12.2802C10.22 12.2802 8.39 13.1302 7 15.0002C7.56 12.3302 9.11 9.67024 13 9.13024V7.00024L16.61 10.3602C16.82 10.5602 16.82 10.8902 16.61 11.0902L13 14.4702Z"
  />
</template>
